var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcThemeW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19C12.5815 19 13.0908 19.4439 13.0908 20.0254V22.9092C13.0908 23.5116 12.6025 24 12 24C11.3975 24 10.9092 23.5116 10.9092 22.9092V20.0254C10.9092 19.4439 11.4185 19 12 19Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13867 17.3174C5.54986 16.9059 6.22628 16.9501 6.6377 17.3613C7.04874 17.7722 7.09331 18.4481 6.68262 18.8594L5.05762 20.4854C4.63147 20.9111 3.94052 20.9105 3.51465 20.4844C3.08888 20.0583 3.08868 19.3673 3.51465 18.9414L5.13867 17.3174Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3623 17.3613C17.7735 16.9503 18.4492 16.9054 18.8604 17.3164L20.4854 18.9414C20.9113 19.3673 20.9111 20.0583 20.4854 20.4844C20.0595 20.9105 19.3685 20.9111 18.9424 20.4854L17.3164 18.8594C16.9057 18.4481 16.9513 17.7723 17.3623 17.3613Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6Z",
    fill: "#F0F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.97461 10.9092C4.55612 10.9092 5 11.4185 5 12C5 12.5815 4.55612 13.0908 3.97461 13.0908H1.09082C0.488369 13.0908 0 12.6025 0 12C1.93267e-07 11.3975 0.488369 10.9092 1.09082 10.9092H3.97461Z",
    fill: "#F0F0F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9092 10.9092C23.5116 10.9092 24 11.3975 24 12C24 12.6025 23.5116 13.0908 22.9092 13.0908H20.0254C19.4439 13.0908 19 12.5815 19 12C19 11.4185 19.4439 10.9092 20.0254 10.9092H22.9092Z",
    fill: "#F0F0F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51465 3.51465C3.94063 3.08867 4.63164 3.08867 5.05762 3.51465L6.68262 5.13965C7.09341 5.55073 7.04863 6.22676 6.6377 6.6377C6.22676 7.04863 5.55073 7.09341 5.13965 6.68262L3.51465 5.05762C3.08867 4.63164 3.08867 3.94063 3.51465 3.51465Z",
    fill: "#F0F0F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9424 3.51465C19.3684 3.08867 20.0594 3.08867 20.4854 3.51465C20.9113 3.94063 20.9113 4.63164 20.4854 5.05762L18.8594 6.68262C18.4483 7.09311 17.7729 7.04858 17.3623 6.6377C16.9514 6.22629 16.9062 5.54975 17.3174 5.13867L18.9424 3.51465Z",
    fill: "#F0F0F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C12.6025 0 13.0908 0.488369 13.0908 1.09082V3.97363C13.0908 4.55511 12.5815 5 12 5C11.4185 5 10.9092 4.55511 10.9092 3.97363V1.09082C10.9092 0.488369 11.3975 1.93269e-07 12 0Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcThemeW);
export default __webpack_public_path__ + "static/media/ic_theme_w.1a7c8c234beeb4827a1e062a4747e63c.svg";
export { ForwardRef as ReactComponent };